export default {
  appIcon: 'kustomer-app-icon',
};
